import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import HistoryPage from "@/pages/HistoryPage";
import BodyWeightPage from "@/pages/BodyWeightPage";
import DietPage from "@/pages/DietPage";
import LoginPage from "@/pages/LoginPage";
import { TryadLogo } from "@/components/TryadLogo";
import { AppProvider } from "@/context/AppContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import "@/App.css";

function SplashScreen() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-4">
      <TryadLogo size={48} className="animate-pulse" />
      <p className="text-xs text-muted-foreground">Cargando tus datos...</p>
    </div>
  );
}

function ProtectedApp() {
  const { user, initializing, syncError, dismissSyncError } = useAuth();

  // Training against a device-only copy while believing it is saved to the
  // cloud is the worst failure mode here, so it must never be silent.
  useEffect(() => {
    if (!syncError) return;
    toast.error(syncError, { duration: 8000, onDismiss: dismissSyncError });
  }, [syncError, dismissSyncError]);

  if (initializing) return <SplashScreen />;
  if (!user) return <LoginPage />;

  return (
    // Keyed by uid so switching accounts rebuilds the app state from the newly
    // synced storage instead of reusing the previous user's in-memory copy.
    <AppProvider key={user.uid}>
      <div className="min-h-screen bg-background font-outfit">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/peso" element={<BodyWeightPage />} />
          <Route path="/dieta" element={<DietPage />} />
        </Routes>
      </div>
    </AppProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ProtectedApp />
        {/* Outside ProtectedApp: sync errors can fire while auth is still
            resolving, and a Toaster mounted later would drop them. */}
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
